import Common from "../../../Common";
import Tts from "./soundfile/Tts";

const Soundfile = class extends Common {
	tts: InstanceType<typeof Tts>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.tts = new Tts(headers);
	}

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/soundfile`);

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/soundfile/${id}`);

	create = (companyId: id, data: any) =>
		this.post(`/company/${companyId}/pbx/soundfile`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/soundfile/${id}`);

	download = (companyId: id, id: id, downloadType: SoundfileDownloadType = 'mp3'): CustomResponse<Blob> =>
		this.get(`/company/${companyId}/pbx/soundfile/${id}/${downloadType}`, {}, { responseType: 'blob' });

	inUse = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/soundfile/${id}/inuse`);
}

export default Soundfile
